import { render, staticRenderFns } from "./department-performance-templates.vue?vue&type=template&id=68c2d014"
import script from "./department-performance-templates.vue?vue&type=script&lang=js"
export * from "./department-performance-templates.vue?vue&type=script&lang=js"
import style0 from "./department-performance-templates.vue?vue&type=style&index=0&id=68c2d014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports